import { push } from 'connected-react-router'
import { put } from 'redux-saga/effects'

export function* navigateTo({ route }) {
  yield put(push(route))
}
